import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss';
import { updateIsShowcase } from '../../slices/header-slice';
import { updatePortfolioData } from '../../slices/app-slice';
import { getPortfolios } from '../../api';
import { useDataLoading } from '../../hooks/useDataLoading';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// import required modules
import Item from '../../components/item';
import { updateHeader } from '../../slices/header-slice';
import SEO from '../../components/seo';
import { useNavigate } from 'react-router-dom';

const Portfolio = ({ setShowcaseItem }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const portfolio = useSelector((state) => state.app.portfolio);

    // Loading state for portfolio data
    const [isPortfolioLoading, setIsPortfolioLoading] = useState(false);
    const hasFetched = useRef(false);

    // Register loading state with global spinner
    useDataLoading('portfolio', isPortfolioLoading, []);

    // Fetch portfolio data if not already populated
    useEffect(() => {
        const fetchPortfolioData = async () => {
            // Check if portfolio has actual data (not just empty array)
            const hasData = portfolio && Array.isArray(portfolio) && portfolio.length > 0;

            if (!hasData && !hasFetched.current) {
                hasFetched.current = true;
                setIsPortfolioLoading(true);
                try {
                    const response = await getPortfolios();
                    // Update only the portfolio data using the dedicated reducer
                    dispatch(updatePortfolioData(response.data));
                } catch (error) {
                    console.error('Error fetching portfolio data:', error);
                } finally {
                    setIsPortfolioLoading(false);
                }
            }
        };

        fetchPortfolioData();
    }, [portfolio, dispatch]);

    useEffect(() => {
        dispatch(updateHeader('light'))
    }, [dispatch]);

    const onShowCaseClick = (item) => {
        if (!item) return; // Safety check
        
        setShowcaseItem(item);
        dispatch(updateIsShowcase(true))
    }

    return (
        <>
            <SEO
                title="Projects — Paramount Wood Co."
                description="We make high end woodwork through dedicated craftsmanship, using only the rarest and finest materials in the world. We have a deep respect for the wood we use, and each piece is built on a unique story, but never one of deforestation. This is our promise."
                name="Paramount Wood Co."
                type="website"
                url="https://paramountwoodco.com/projects"
            />
            <div className="portfolio">

                <div className="portfolio-intro">

                    <h1>Our Portfolio</h1>
                    <p>We invite you to browse a curated selection of our projects - showcasing the broad scope of our work.
                        Here you'll find a wide range of wood species and styles. Pure hand crafted bespoke design enjoyed in spaces around the world.</p>
                    <br />
                    <p>For best viewing, please use a tablet or desktop device.</p>

                    <button className="cta gold-fill" onClick={() => navigate("/look-book")}>View ~ Portfolio 2026 edition ~</button>
                </div>

                <div className="portfolio-content items">

                    {portfolio && Array.isArray(portfolio) && portfolio.length > 0 ? (
                        portfolio.map((item, i) => (
                            <Item key={i} item={item} index={i} setItem={onShowCaseClick} />
                        ))
                    ) : (
                        <div className="no-portfolio">
                            <p>No portfolio items available at the moment.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Portfolio;